import React, { useContext } from 'react'
import { styled } from '@mui/material'
import { Box, CircularProgress, Typography } from '@mui/material'
import { SectionContext } from '../Section/Context'
import { ConnectModuleForm } from '../ConnectModuleForm'
import { useConnectModuleFormReturnType } from '../../containers/PageSectionConnectModule/useConnectModuleForm'

const Wrapper = styled('div')`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  max-width: 800px;
`

interface SectionContentConnectModuleProps {
  heading: React.ReactNode
  prosHeading?: React.ReactNode
  form: useConnectModuleFormReturnType
  headingComponent?: 'h1' | 'h2'
}

export const SectionContentConnectModule: React.FunctionComponent<
  SectionContentConnectModuleProps
> = ({ heading, prosHeading, form, headingComponent = 'h2' }) => {
  const { theme } = useContext(SectionContext)

  let activeHeading = heading

  if (form.role === 'Pro' && prosHeading) {
    activeHeading = prosHeading
  }
  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', position: 'relative' }}
    >
      <Wrapper>
        <Typography
          variant="h2"
          component={headingComponent}
          sx={{
            color: theme === 'dark' ? 'primary.contrastText' : 'textPrimary',
          }}
          align="center"
        >
          {activeHeading}
        </Typography>
        <Box sx={{ position: 'relative' }}>
          {form.loading && (
            <Box
              sx={{
                position: 'absolute',
                zIndex: 300,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 1,
                backgroundColor: (theme) => theme.palette.background.paper,
                opacity: 0.8,
              }}
            >
              <CircularProgress color="secondary" />
            </Box>
          )}
          <Box
            sx={[
              { p: 2 },
              (_theme) => ({
                backgroundColor: 'rgba(255, 255, 255, 0.80)',
                border: '1px solid',
                borderColor: 'neutral.lightGray',
                borderRadius: 1,
              }),
            ]}
          >
            <ConnectModuleForm {...form} />
          </Box>
        </Box>
      </Wrapper>
    </Box>
  )
}
